import React from "react";
import { ThemeProvider, injectGlobal } from "styled-components";
import { compose } from "recompose";
import Helmet from "react-helmet";
import BrowserRouter from "react-router-dom/BrowserRouter";

import AppComponent from "package-common-react/lib/components/App";

import normalize from "package-common-react/assets/normalize.css";
import theme from "./theme";

import global from "./css/global.css";
import AppPages from "./components/AppPages";

injectGlobal(normalize, global);

export default compose()(function App() {
  return (
    <ThemeProvider theme={theme}>
      <AppComponent>
        <Helmet titleTemplate="%s | PIÈCES&nbsp;AUTO">
          <title>Quiz Cahier de Vacances</title>
          <link
            href="https://fonts.googleapis.com/css?family=Poppins:400,600"
            rel="preload"
            as="style"
          />
          <link
            rel="apple-touch-icon"
            sizes="180x180"
            href="/apple-touch-icon.png"
          />
          <link
            rel="icon"
            type="image/png"
            sizes="32x32"
            href="/favicon-32x32.png"
          />
          <link
            rel="icon"
            type="image/png"
            sizes="16x16"
            href="/favicon-16x16.png"
          />
          <link rel="manifest" href="/site.webmanifest" />
          <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#193d83" />
          <meta name="msapplication-TileColor" content="#193d83" />
          <meta name="theme-color" content="#ffffff" />
        </Helmet>
        <BrowserRouter>
          <AppPages />
        </BrowserRouter>
      </AppComponent>
    </ThemeProvider>
  );
});



// WEBPACK FOOTER //
// ./src/App.js